// Методика v2: вес блока «Отношение» (оценка МО). Используется для перевода вклада в 5-балльную оценку.
export const RELATION_BLOCK_WEIGHT = 0.2;

// Дата начала действия методики v2 (показывается под вкладкой «Рейтинг 2.0»).
// TODO: уточнить у бэка источник даты — пока константа.
export const V2_EFFECTIVE_FROM = '01.07.2026';

// Конец действия прежней методики v1 (показывается под вкладкой «Рейтинг 1.0»).
export const V1_EFFECTIVE_TO = '30.06.2026';

export enum EColors {
  DEFAULT = '#FFF',
  GREEN = '#E0F5EB',
  YELLOW = '#FFECCF',
  RED = '#FFD9E2',
}

export const RATING_COUNT_LABELS = [
  { primary: 'от 4,5 до 5', secondary: 'Продолжаем работать с партнером. Мотивируем команду и благодарим!', value: 5 },
  {
    primary: 'от 3,5 до 4,4',
    secondary: 'Показываем команде партнера точки роста, уточняем что нужно улучшить',
    value: 3.5,
  },
  {
    primary: 'от 0 до 3,4',
    secondary: 'Показываем точки роста партнеру, если 3 месяца он не выходит с красной зоны - меняем партнера',
    value: 3.4,
  },
];
